export default __webpack_public_path__ + "static/media/login1.2a0b8c96.png";